import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  class: "mapv3-panel mapv3-panel--info",
  "aria-label": "Szczegóły pojazdu"
}
const _hoisted_2 = { class: "mapv3-panel__header" }
const _hoisted_3 = { class: "mapv3-panel__header-top" }
const _hoisted_4 = { class: "mapv3-panel__title-wrap" }
const _hoisted_5 = { class: "mapv3-panel__plate" }
const _hoisted_6 = { class: "mapv3-panel__model" }
const _hoisted_7 = { class: "mapv3-panel__header-actions" }
const _hoisted_8 = ["title"]
const _hoisted_9 = {
  key: 0,
  class: "mapv3-panel__driver"
}
const _hoisted_10 = { class: "mapv3-panel__driver-main" }
const _hoisted_11 = { class: "mapv3-panel__driver-name" }
const _hoisted_12 = { class: "mapv3-panel__driver-meta" }
const _hoisted_13 = {
  class: "mapv3-panel__tabs",
  role: "tablist"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "mapv3-panel__content" }
const _hoisted_16 = { class: "mapv3-panel__tab-pane" }
const _hoisted_17 = { class: "mapv3-tacho__progress-card" }
const _hoisted_18 = { class: "mapv3-tacho__progress-head" }
const _hoisted_19 = { class: "mapv3-tacho__progress-label" }
const _hoisted_20 = { class: "mapv3-tacho__progress-value" }
const _hoisted_21 = { class: "mapv3-tacho__bar" }
const _hoisted_22 = { class: "mapv3-tacho__caption" }
const _hoisted_23 = {
  key: 0,
  class: "mapv3-tacho__state"
}
const _hoisted_24 = {
  key: 1,
  class: "mapv3-tacho__state"
}
const _hoisted_25 = { class: "mapv3-section-title" }
const _hoisted_26 = { class: "mapv3-row__label" }
const _hoisted_27 = ["title"]
const _hoisted_28 = { class: "mapv3-panel__tab-pane" }
const _hoisted_29 = {
  key: 0,
  class: "mapv3-tacho__state"
}
const _hoisted_30 = {
  key: 1,
  class: "mapv3-can__grid"
}
const _hoisted_31 = { class: "mapv3-can__tile-head" }
const _hoisted_32 = { class: "mapv3-can__tile-value" }
const _hoisted_33 = {
  key: 0,
  class: "mapv3-can__tile-unit"
}
const _hoisted_34 = {
  key: 1,
  class: "mapv3-can__tile-sub"
}
const _hoisted_35 = {
  key: 0,
  class: "mapv3-tacho__bar"
}
const _hoisted_36 = { class: "mapv3-panel__tab-pane" }
const _hoisted_37 = { class: "mapv3-trasa__ranges" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 0,
  class: "mapv3-trasa__picker"
}
const _hoisted_40 = { class: "mapv3-trasa__picker-head" }
const _hoisted_41 = { class: "mapv3-trasa__picker-grid" }
const _hoisted_42 = { class: "mapv3-trasa__field" }
const _hoisted_43 = { class: "mapv3-trasa__field" }
const _hoisted_44 = {
  key: 0,
  class: "mapv3-trasa__error"
}
const _hoisted_45 = { class: "mapv3-trasa__picker-actions" }
const _hoisted_46 = {
  key: 1,
  class: "mapv3-trasa__empty"
}
const _hoisted_47 = { class: "mapv3-section-title" }
const _hoisted_48 = { class: "mapv3-row__label" }
const _hoisted_49 = { class: "mapv3-row__value" }
const _hoisted_50 = { class: "mapv3-section-title" }
const _hoisted_51 = {
  key: 0,
  class: "mapv3-trasa__empty"
}
const _hoisted_52 = { class: "mapv3-trasa__event-main" }
const _hoisted_53 = { class: "mapv3-trasa__event-title" }
const _hoisted_54 = { class: "mapv3-trasa__event-time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.vehicle._plate || _ctx.vehicle.registration || _ctx.vehicle.imei), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.vehicle.model || _ctx.vehicle.name || '—'), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", {
            class: "mapv3-panel__status-badge",
            style: _normalizeStyle({ background: _ctx.statusPalette.tint, color: _ctx.statusPalette.color })
          }, _toDisplayString(_ctx.statusLabel), 5),
          _createElementVNode("button", {
            class: "mapv3-panel-close",
            type: "button",
            title: _ctx.$t('components.map.list.collapse'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("i", { class: "bi bi-x-lg" }, null, -1)
          ]))], 8, _hoisted_8)
        ])
      ]),
      (_ctx.hasTacho)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "mapv3-panel__driver-avatar",
              style: _normalizeStyle({ background: _ctx.statusPalette.color })
            }, _toDisplayString(_ctx.driverInitials), 5),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.driverName), 1),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.currentCard ? ('Karta ' + _ctx.currentCard) : _ctx.$t('components.map.panel.noCard')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_13, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("button", {
          key: tab,
          class: _normalizeClass(["mapv3-panel__tab", { 'mapv3-panel__tab--active': _ctx.activeTab === tab }]),
          type: "button",
          role: "tab",
          onClick: ($event: any) => (_ctx.activeTab = tab)
        }, _toDisplayString(_ctx.$t('components.map.panel.tabs.' + tab)), 11, _hoisted_14))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_15, [
      _withDirectives(_createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('components.map.panel.tacho.continuous')), 1),
            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.continuous.text), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", {
              class: "mapv3-tacho__bar-fill",
              style: _normalizeStyle({ width: _ctx.continuous.pct + '%', background: _ctx.continuous.color })
            }, null, 4)
          ]),
          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('components.map.panel.tacho.remaining', { v: _ctx.continuous.remaining })), 1)
        ]),
        (_ctx.loadingTacho)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.$t('components.map.panel.loading')), 1))
          : (!_ctx.contract)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.currentCard ? _ctx.$t('components.map.panel.tacho.noDriver') : _ctx.$t('components.map.panel.tacho.pick')), 1))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.tachoSections, (section) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: section.title
                }, [
                  _createElementVNode("div", _hoisted_25, _toDisplayString(section.title), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.rows, (row) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: row.label,
                      class: "mapv3-row"
                    }, [
                      _createElementVNode("span", _hoisted_26, [
                        _createTextVNode(_toDisplayString(row.label), 1),
                        (row.source && row.source !== 'none')
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(["mapv3-tacho__source", 'mapv3-tacho__source--' + row.source]),
                              title: _ctx.sourceTitle(row.source)
                            }, _toDisplayString(_ctx.sourceLabel(row.source)), 11, _hoisted_27))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", {
                        class: _normalizeClass(["mapv3-row__value", { 'mapv3-row__value--wrap': row.wrap }])
                      }, _toDisplayString(row.value), 3)
                    ]))
                  }), 128))
                ], 64))
              }), 128))
      ], 512), [
        [_vShow, _ctx.activeTab === 'tacho']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_28, [
        (!_ctx.canCards.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.$t('components.map.panel.can.empty')), 1))
          : _createCommentVNode("", true),
        (_ctx.canCards.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.canCards, (card) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: card.key,
                  class: _normalizeClass(["mapv3-can__tile", { 'mapv3-can__tile--wide': card.bar }])
                }, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("i", {
                      class: _normalizeClass('bi ' + card.icon)
                    }, null, 2),
                    _createElementVNode("span", null, _toDisplayString(card.label), 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createTextVNode(_toDisplayString(card.value), 1),
                    (card.unit)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(card.unit), 1))
                      : _createCommentVNode("", true),
                    (card.sub)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, " · " + _toDisplayString(card.sub), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (card.bar)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createElementVNode("div", {
                          class: "mapv3-tacho__bar-fill",
                          style: _normalizeStyle({ width: card.barPct + '%', background: card.barColor || _ctx.statusPalette.color })
                        }, null, 4)
                      ]))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 512), [
        [_vShow, _ctx.activeTab === 'can']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['day', 'week', 'custom'], (r) => {
            return _createElementVNode("button", {
              key: r,
              class: _normalizeClass(["mapv3-trasa__range", { 'mapv3-trasa__range--active': _ctx.trackRange === r }]),
              type: "button",
              onClick: ($event: any) => (_ctx.setRange(r))
            }, _toDisplayString(_ctx.$t('components.map.panel.trasa.ranges.' + r)), 11, _hoisted_38)
          }), 64))
        ]),
        (_ctx.showCustomPicker)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.$t('components.map.panel.trasa.customTitle')), 1),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("label", _hoisted_42, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.map.panel.trasa.from')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customFrom) = $event)),
                    type: "datetime-local",
                    step: "60"
                  }, null, 512), [
                    [_vModelText, _ctx.customFrom]
                  ])
                ]),
                _createElementVNode("label", _hoisted_43, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.map.panel.trasa.to')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.customTo) = $event)),
                    type: "datetime-local",
                    step: "60"
                  }, null, 512), [
                    [_vModelText, _ctx.customTo]
                  ])
                ])
              ]),
              (_ctx.rangeError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_ctx.rangeError), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("button", {
                  class: "mapv3-trasa__btn mapv3-trasa__btn--ghost",
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelCustom && _ctx.cancelCustom(...args)))
                }, _toDisplayString(_ctx.$t('components.map.panel.trasa.cancel')), 1),
                _createElementVNode("button", {
                  class: "mapv3-trasa__btn mapv3-trasa__btn--primary",
                  type: "button",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.applyCustomRange && _ctx.applyCustomRange(...args)))
                }, _toDisplayString(_ctx.$t('components.map.panel.trasa.apply')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.loadingRoute)
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_ctx.$t('components.map.panel.loading')), 1))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t('components.map.panel.trasa.summary')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trasaRows, (row) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: row.label,
                  class: "mapv3-row"
                }, [
                  _createElementVNode("span", _hoisted_48, _toDisplayString(row.label), 1),
                  _createElementVNode("span", _hoisted_49, _toDisplayString(row.value), 1)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t('components.map.panel.trasa.events')), 1),
              (!_ctx.routeEvents.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(_ctx.$t('components.map.panel.trasa.eventsEmpty')), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routeEvents, (ev, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "mapv3-trasa__event"
                }, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "mapv3-trasa__event-icon" }, [
                    _createElementVNode("i", { class: "bi bi-p-square" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t('components.map.panel.trasa.eventStop')) + " · " + _toDisplayString(ev.duration), 1),
                    _createElementVNode("div", _hoisted_54, _toDisplayString(ev.time), 1)
                  ])
                ]))
              }), 128))
            ], 64))
      ], 512), [
        [_vShow, _ctx.activeTab === 'trasa']
      ])
    ])
  ]))
}